import { render, staticRenderFns } from "./volumeLeft.vue?vue&type=template&id=810dc1c8&scoped=true"
import script from "./volumeLeft.vue?vue&type=script&lang=js"
export * from "./volumeLeft.vue?vue&type=script&lang=js"
import style0 from "./volumeLeft.vue?vue&type=style&index=0&id=810dc1c8&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810dc1c8",
  null
  
)

export default component.exports